
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scuoladellinfanzia/[slug]",
      function () {
        return require("private-next-pages/scuoladellinfanzia/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scuoladellinfanzia/[slug]"])
      });
    }
  